export * from "./privacy-policy";
export * from "./terms-and-conditions";
export * from "./shipping-and-delivery";
